var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Calculateur',{attrs:{"msg":"Bienvenue sur notre calculateur"},on:{"edit":_vm.editRepair,"showmodal":_vm.showModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }